//roi
import request from '@/utils/request';
export function getRollData(data) {
  return request({
    url: '/data/roll_server_data',
    method: 'get',
    params: data
  });
}